<template>
    <el-skeleton :rows="12" :loading="loading" animated>
        <template #default>

            <el-form ref="formRef" :disabled="saving" :rules="rules" :model="ad" label-position="top">
                <el-form-item prop="name" label="Nome do local">
                    <el-input name="name" v-model="ad.name" />
                </el-form-item>

                <el-form-item label="Selecionar categoria" prop="category_id">
                    <el-select v-model="ad.category_id">
                        <el-option :label="c.name" v-for="c in categories" :value="c.id" :key="c.id">{{ c.name }}</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="images" label="Adicione fotos do local">
                    <el-input multiple v-model="uris" type="file" ref="images" name="images" @change="selectImages" />
                </el-form-item>

                <el-form-item label="Descrição" prop="description">
                    <el-input type="textarea" name="description" v-model="ad.description" minlength="1" />
                </el-form-item>

                <el-form-item label="Localização" prop="area.name" v-if="ad.area">
                    <el-input name="loc" v-model="ad.area.name" minlength="1" />
                </el-form-item>

                <el-form-item label="Selecione o local no mapa">
                    <div style="height: 400px; width: 100%" class="position-relative">
                        <el-button plain class="position-absolute end-0" style="z-index: 1024;" :loading="locating || loading" size="large" type="success" @click.prevent="locate">
                            Localizar-me
                        </el-button>
                        <l-map ref="map" :zoom="zoom" :center="[ad.area?.lat ?? 0, ad.area?.long ?? 0]" @contextmenu="onMapClick">
                            <l-tile-layer
                                url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                                layer-type="base"
                                name="Google"
                            ></l-tile-layer>

                            <l-marker v-if="ad.area" :lat-lng="[ad.area.lat, ad.area.long]">
                                <l-tooltip>{{ ad.name }}</l-tooltip>
                            </l-marker>
                        </l-map>
                    </div>
                </el-form-item>
        
                <el-button plain  :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
                    Cadastrar
                </el-button>
            </el-form>

        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Ad, Area, Category } from "@/services/types"
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus"
    import { onBeforeMount, reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip, } from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'

    const store = useStore()
    const router = useRouter()
    const ad = reactive<Ad>({
        name: '',
        description: '',
        images: [],
        category_id: null,
        area: reactive<Area>({
            name: 'Bairo, rua, outras',
            lat: -19.84361, 
            long: 34.83889
        })
    })

    const rules = reactive<FormRules<Ad>>({
        name: [{required: true, message: 'Insira o nome do sitio', min: 1}],
        description: [{required: true, message: 'Informe a descricao'}],
        category_id: [{required: true, message: 'Precisa selecionar uma categoria'}],
        "area.name": [{required: true, message: 'Fornrça a localizacao'}],
        images: [{required: true, message: 'adicione pelo menos uma foto'}]
    })

    const images = ref()
    const uris = ref<string>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)
    const map = ref()
    const zoom = ref<number>(15)
    const locating = ref<boolean>(false)

    const onMapClick = (event: LeafletMouseEvent) => {
        const { lat, lng } = event.latlng
        if (ad.area) {
            ad.area.lat = lat
            ad.area.long = lng
        } else {
            ad.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(ad.area);
    }
    
    const categories = reactive<Array<Category>>([])

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('admin/categories')
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message)
        } else {
            const data = res.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }
        loading.value = false
    })


    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (ad.area) {
                ad.area.lat = position.coords.latitude
                ad.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const selectImages = () => {
        console.log(images.value?.input.files)
        ad.images?.splice(0)
        for (let i = 0; i < images.value?.input.files.length; i++) {
            ad.images?.push(images.value?.input.files[i])
        }

        console.log(ad.images)
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!ad.area?.lat || !ad.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = new FormData()
                data.append('name', ad.name)
                data.append('category_id', `${ad.category_id}`)
                data.append('description', ad.description)
                
                // Area
                if (ad.area) {
                    data.append('area[name]', ad.area.name)
                    data.append('area[lat]', ad.area.lat.toString())
                    data.append('area[long]', ad.area.long.toString())
                }
                

                // imagens
                ad.images?.forEach((img, i) => {
                    data.append(`images[${i}]`, img)
                })

                const res = await Api.post('admin/ads', ad, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Local cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                    
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>

<!-- <style lang="scss">
    .locate-btn {
        
    }
</style> -->
